import { defineAction } from '~/prix'
import residencePropagateToGeneralAction from './residencePropagateToGeneral.action.json' with { type: 'json' }
import { z } from 'zod'

const residencePropagateToGeneralDefinition = defineAction({
  ...residencePropagateToGeneralAction,

  input: z.object({
    testOnly: z.boolean().optional(),
    debug: z.boolean().optional(),
    dataSourceIdentifiers: z.array(z.number().int().positive()).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    testOnly: z.boolean(),
    blocked: z.boolean(),
    blockers: z.array(z.string()),
    metrics: z.object({
      source: z.record(z.string(), z.union([z.number(), z.string(), z.null()])),
      quality: z.record(z.string(), z.number()),
      residences: z.record(z.string(), z.number()),
      citizens: z.record(z.string(), z.number()),
      relationships: z.record(z.string(), z.number()),
      validation: z.record(z.string(), z.number()),
      writes: z.record(z.string(), z.number()),
      timingMilliseconds: z.record(z.string(), z.number()),
    }),
  }),
})

export default residencePropagateToGeneralDefinition
